import { cleanString, cn } from '@/lib/utils'
import { urlForImage } from '@/sanity/lib/image'
import MuxVideo from '@/components/MuxVideo'
import Image from 'next/image'
import Link from 'next/link'

interface ProjectCardProps {
	title: string
	subtitle: string
	url: string
	image?: any
	video?: any
	aspect?: string
}

export default function ProjectCard({ title, subtitle, url, image, video, aspect = '1/1' }: ProjectCardProps) {
	return (
		<Link
			href={url}
			className="text-lg leading-100 group">
			<div
				className="relative mb-4 rounded-[8px] overflow-clip mobile:aspect-[1/1!important]"
				style={{ aspectRatio: cleanString(aspect) }}
			>
				{image && (
					<Image
						className="w-full h-full object-cover"
						src={urlForImage(image).width(3840).url()}
						sizes={cleanString(aspect) === "16/9" ? `100vw` : `(min-width: 1024px) 50vw, 100vw`}
						width={image?.asset?.metadata?.dimensions?.width}
						height={image?.asset?.metadata?.dimensions?.height}
						alt={title}
						placeholder="blur"
						blurDataURL={image?.asset?.metadata?.lqip}
						quality={90}
					/>
				)}
				{video && (
					<MuxVideo
						className={cn(`block w-full h-full object-cover`, {
							"absolute inset-0 opacity-0 sm:group-hover:opacity-100 transition-opacity mobile:hidden" : image,
							"relative" : !image
						})}
						playbackId={video?.asset?.playbackId}
						autoplay={image ? 'hover' : true}
						loop={true}
						showAudioToggle={false}
					/>
				)}
			</div>
			<div className="title">{title}</div>
			<div className="mt-1 text-grey dark:text-grey-dark">{subtitle}</div>
		</Link>
	)
}
